import "./ShaktipethaView.scss";
import ShaktipeethaDetailsCard from "../../components/card/Temple/ShaktipeethaDetailsCard";
import { Box, Grid } from "@mui/material";

function ShaktipethaView(props: any) {
  return (
    <Box className="pageContainer shaktipethaPage">
      <Box className="templeBlock">
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} lg={2} xl={2} className="pagehdLeftBlock">
            {/* <LeftAddressCard
              header={props.TDTexts.CURRENTADDRESS}
              address={
                props.userAddressList && props.userAddressList.length > 0
                  ? props.userAddressList[0].formatted_address
                  : ""
              }
              footerButton="Edit or add an address"
            /> */}
          </Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="shaktipethaCenterBlock">
              {props.templeList &&
                props.templeList &&
                props.templeList.map((item: any, id: any) => {
                  return (
                    <ShaktipeethaDetailsCard
                      id={id}
                      templeData={item}
                      templePictures={
                        item.personalInfo &&
                        item.personalInfo.media &&
                        item.personalInfo.media.pictures
                          ? item.personalInfo.media.pictures
                          : []
                      }
                      templeImage={
                        item.personalInfo &&
                        item.personalInfo.media &&
                        item.personalInfo.media.pictures &&
                        item.personalInfo.media.pictures.length > 0
                          ? item.personalInfo.media.pictures[0].pictureUrl
                          : ""
                      }
                      verificationStatus={""}
                      templeName={item.personalInfo.name}
                      descriptions={item.personalInfo.descriptions}
                      // descriptions='The Jagannath Temple is an important Hindu temple dedicated to Jagannath, a form of Vishnu–one of the trinity of supreme'
                      selectTemple={props.selectTemple}
                      googleData={item.googleData}
                      onboarded={item.onboarded}
                      onClickNavigateToTemple={props.onClickNavigateToTemple}
                      templeId={item.templeId}
                    />
                  );
                })}
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="pagehdRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ShaktipethaView;
